import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'styled-bootstrap-grid';
import { Box } from '@ch/common/components/box';
import { useData } from '../use-data';
import { assetsPath } from '../const';
import HomeReport from './home-report';
import HomeContact from './home-contact';
import { HomeImg } from './home.styled';
import { HomeNavigation } from './home-navigation';
import ModalSimple from '@ch/common/components/modal/modals/simple-modal';

const Home: FC = () => {
  const [showTimeout, setShowTimeout] = useState(false);
  const {
    data: {
      home,
      keywords: { sessionInactivity, okayButton },
      theme: { btnDark },
    },
  } = useData();

  const search = useLocation().search;
  const queryParams = new URLSearchParams(search);
  const timeout = queryParams.get('timeout');

  useEffect(() => {
    setShowTimeout(!!timeout);
  }, [timeout]);

  if (!home) {
    return null;
  }

  const {
    images: {
      home: { url: imgUrl, altText },
    },
  } = home;

  return (
    <>
      {imgUrl && <HomeImg src={`${assetsPath}/${imgUrl}`} alt={altText} />}
      <Box $p={[50, 0]}>
        <Container>
          <Row justifyContent="center">
            <Col xl={8} lg={10}>
              <HomeReport />
              <Box $p={[30, 30, 5]} $m={[0, 0, 40]} $bgColor="grayLighter">
                <HomeContact />
              </Box>
              <HomeNavigation $color="red" $m={[0, 15]} />
            </Col>
          </Row>
        </Container>
      </Box>
      <ModalSimple
        isOpen={showTimeout}
        hideClose
        btnTheme={btnDark}
        onSubmit={{
          title: okayButton,
          action: () => {
            setShowTimeout(false);
            window.history.replaceState &&
              window.history.replaceState(
                null,
                '',
                window.location.pathname + window.location.search.replace(/[/?&]timeout=[^&]+/, '').replace(/^&/, '?'),
              );
          },
        }}
      >
        <span>{sessionInactivity}</span>
      </ModalSimple>
    </>
  );
};

export default Home;
